<template>
  <main-template>
    <v-row align="center" class="mb-2">
      <v-col>
        <h1 class="text-h5 font-weight-bold d-flex align-center">
          <v-btn color="primary" x-small text class="mr-2" @click="$router.go(-1)">
            <v-icon left>fa fa-angle-left</v-icon>
          </v-btn>
          Minhas Férias
        </h1>
      </v-col>
    </v-row>

    <v-card outlined>
      <v-data-table
        :headers="headers"
        :items="ferias"
        :loading="carregando"
        no-data-text="Você não possui registros de férias cadastrados"
        loading-text="Carregando suas férias..."
        class="elevation-0"
      >
        <template #[`item.periodo`]="{ item }">
          <div class="font-weight-bold">
            <v-icon small class="mr-1" color="primary">mdi-calendar-range</v-icon>
            {{ formatarData(item.data_inicio) }} até {{ formatarData(item.data_fim) }}
          </div>
          <small class="grey--text">
            ({{ calcularDias(item.data_inicio, item.data_fim) }} dias)
          </small>
        </template>

        <template #[`item.tipo`]="{ item }">
          <v-chip x-small outlined color="info" class="text-capitalize">
            {{ formatarTipo(item.tipo) }}
          </v-chip>
        </template>

        <template #[`item.status`]="{ item }">
          <v-chip small :color="corStatus(item.status)" dark class="font-weight-bold">
            {{ formatarStatus(item.status) }}
          </v-chip>
        </template>

        <template #[`item.observacoes`]="{ item }">
          <span>{{ item.observacoes || "—" }}</span>
        </template>
      </v-data-table>
    </v-card>
  </main-template>
</template>

<script>
export default {
  name: "MinhasFeriasPage",
  data() {
    return {
      carregando: false,
      ferias: [],
      headers: [
        { text: "Período das Férias", value: "periodo", sortable: false },
        { text: "Tipo", value: "tipo", sortable: false },
        { text: "Status", value: "status", sortable: false },
        { text: "Observações", value: "observacoes", sortable: false },
      ],
    };
  },
  async mounted() {
    await this.carregarMinhasFerias();
  },
  methods: {
    async carregarMinhasFerias() {
      this.carregando = true;
      try {
        const response = await this.$services.colaboradorFeriasService.listarMinhas();
        if (response && Array.isArray(response.data)) {
          this.ferias = response.data;
        } else if (response && response.data && Array.isArray(response.data.data)) {
          this.ferias = response.data.data;
        } else if (Array.isArray(response)) {
          this.ferias = response;
        } else {
          this.ferias = [];
        }
      } catch (e) {
        this.ferias = [];
      } finally {
        this.carregando = false;
      }
    },
    formatarData(dt) {
      if (!dt) return "—";
      const parts = dt.split("-");
      if (parts.length === 3) {
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
      }
      return dt;
    },
    calcularDias(inicio, fim) {
      if (!inicio || !fim) return 0;
      const d1 = new Date(inicio);
      const d2 = new Date(fim);
      const diffTime = Math.abs(d2 - d1);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
      return diffDays;
    },
    formatarTipo(tipo) {
      const mapa = {
        regular: "Regular",
        coletivas: "Coletivas",
        fracionada: "Fracionada",
      };
      return mapa[tipo] || tipo || "Regular";
    },
    formatarStatus(st) {
      const mapa = {
        agendado: "Agendado",
        em_andamento: "Em Andamento",
        concluido: "Concluído",
        cancelado: "Cancelado",
      };
      return mapa[st] || st;
    },
    corStatus(st) {
      const mapa = {
        agendado: "info",
        em_andamento: "success",
        concluido: "grey darken-1",
        cancelado: "error",
      };
      return mapa[st] || "primary";
    },
  },
};
</script>
